<template>
  <Calendar
    :events="slots"
    @event-selected="selectEvent"
    :type="type"
    :hoverEffect="false"
    @update-range="updateRange"
  />
</template>

<script>
import GlobalMixin from "../../GlobalMixin";
import Calendar from "../global/calendar.vue";

export default {
  name: "SessionsList",
  mixins: [GlobalMixin],
  components: { Calendar },
  props: {
    slots: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  methods: {
    /**
     * Select event onSelect
     * @param event event object
     */
    selectEvent(event) {
      this.styleSelectedSession(event);
      if (event.name === "Reserved" && !event.reserved) return;
      if (event.name === "Available" && !event.reserved)
        return this.$store.dispatch("removeSelectedSlot", event.id);
      this.$store.dispatch("saveSelectedSlot", event);
    },
    /**
     * Style Event onSelect
     * @param event event object
     */
    styleSelectedSession(event) {
      if (event.name === "Reserved")
        return this.showAlert(this.$t("reservation.reservedSlot"), "error");
      if (event.color === "primary") {
        event.reserved = false;
        return (event.color = "#eff6ff");
      }
      event.reserved = true;
      event.color = "primary";
    },
    /**
     * Update range of sessions
     * @param options date object
     */
    updateRange(options) {
      this.$emit("update-sessions", options);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .v-sheet {
  .v-calendar {
    .v-calendar-weekly__head {
      *:not(.v-present) {
        color: $black;
      }
    }
    .v-calendar-weekly__week {
      .v-calendar-weekly__day.v-past {
        color: $black !important;
        background: #e1e1e1 !important;
        pointer-events: none;
        .v-btn__content {
          color: $black !important;
        }
      }
    }
    .v-calendar-daily__head {
      .v-past {
        background: #e1e1e1 !important;
        pointer-events: none;
        button,
        .v-calendar-daily_head-weekday {
          color: $black !important;
        }
      }
    }
    .v-calendar-daily__day {
      &.v-past {
        color: $black !important;
        background: #e1e1e1 !important;
        pointer-events: none;
      }
    }
  }
}
</style>
